// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__79pTH","footer":"ChangeClinic_footer__nvv6_"};